@import (reference) '../../../../../constants/spacing.module.less';
@import './shipment-activity-global.less';

.shipment-activity-section-content {
  padding: @space-0 @space-16 @space-16;
}

.fulfillment-plan-activity-list {
  // Global styles moved to shipment-activity-global.less
}
